<script lang="ts">
  import { tStore } from '../../../i18n'
  import StatusBadge from '../../../components/StatusBadge.svelte'
  import { formatDateTime } from '../../../composables/format'
  import { resolveSourceLabel, type SourceLabels } from '../../../composables/sourceNames'
  import type { RetrievalRun } from '../../../api/retrievals'

  let {
    runs,
    sourceLabels,
    tableHeight = $bindable(undefined),
  }: { runs: RetrievalRun[]; sourceLabels: SourceLabels; tableHeight?: number } = $props()

  function runTone(s: RetrievalRun['status']) {
    if (s === 'success') return 'success' as const
    if (s === 'failed') return 'danger' as const
    return 'info' as const
  }
</script>

<article class="card">
  <h3>{$tStore('views.dashboard.recentRuns')}</h3>
  <table class="table" bind:clientHeight={tableHeight}>
    <thead>
      <tr>
        <th>{$tStore('views.ingestionRuns.columns.source')}</th>
        <th>{$tStore('views.ingestionRuns.columns.startedAt')}</th>
        <th>{$tStore('views.ingestionRuns.columns.status')}</th>
        <th>
          <abbr class="metric-help" title={$tStore('views.ingestionRuns.columnHelp.found')}>
            {$tStore('views.ingestionRuns.columns.found')}
          </abbr>
        </th>
        <th>
          <abbr class="metric-help" title={$tStore('views.ingestionRuns.columnHelp.new')}>
            {$tStore('views.ingestionRuns.columns.new')}
          </abbr>
        </th>
        <th>
          <abbr class="metric-help" title={$tStore('views.ingestionRuns.columnHelp.updated')}>
            {$tStore('views.ingestionRuns.columns.updated')}
          </abbr>
        </th>
      </tr>
    </thead>
    <tbody>
      {#each runs as r (r.id)}
        <tr>
          <td>{resolveSourceLabel(sourceLabels, r.sourceName)}</td>
          <td>{formatDateTime(r.startedAt)}</td>
          <td>
            <StatusBadge
              label={$tStore(`views.ingestionRuns.status.${r.status}`)}
              tone={runTone(r.status)}
            />
          </td>
          <td>{r.procurementsFound}</td>
          <td>{r.procurementsNew}</td>
          <td>{r.procurementsUpdated}</td>
        </tr>
      {/each}
    </tbody>
  </table>
</article>

<style lang="scss">
  .metric-help {
    cursor: help;
    text-decoration: underline dotted;
    text-underline-offset: 0.18em;
  }
</style>
